<template>
    <div class="art-cont">
                    <h1 class="fs28 lh38">“星火·链网”骨干节点（珠海横琴）上线发布 创新赋能数字贸易</h1>
                    <div class="title-info">2021-12-01</div>
                    <div class="main-content">
                        <p>
	11月30日，2021粤港澳数字贸易创新应用峰会暨“星火·链网”骨干节点（珠海横琴）-横琴粤澳链发布会在粤澳合作中医药科技产业园举行。峰会上探讨了数字技术如何赋能数字贸易，助力横琴粤澳深度合作区及粤港澳大湾区高质量发展等议题,并宣布了“星火·链网”骨干节点（珠海横琴）-横琴粤澳链正式上线运行。
</p>
<p>
	<br>
</p>
<p>
	“星火·链网”骨干节点（珠海横琴）由浪潮云洲旗下的广东云湾工业互联网有限公司承建，珠海横琴融贯国际科技发展公司运营，依托浪潮及泰尔英福的区块链技术而设计的湾区第一个节点，同时也是华南地区第一个面向海外的骨干节点。
</p>
<p>
	<br>
</p>
<p>
	“星火·链网”骨干节点（珠海横琴）是基于“星火·链网”体系，依托浪潮云洲工业互联网平台，面向粤港澳大湾区提供的数字金融、数字民生、数字产业和创新应用服务，通过可信数据服务于电子、商贸、文旅、生物医药等数字贸易场景，为澳门产业多元发展创造条件；为国家打造自主可控的标识解析体系、标准体系、安全管理体系，提供多场景的落地实践。
</p>
<p>
	<br>
</p>
<p>
	“星火·链网”骨干节点（珠海横琴）建成后，将全面覆盖民生、金融、中医药等多个领域，探索多个场景应用，为粤港澳贸易经济的发展注入新动能。
</p>
<p>
	<br>
</p>
<p style="text-align:center;">
	<img src="/core/extend/kindeditor/attached/image/20220228/20220228174619_21920.jpg" alt="" ondragstart="return false">
</p>
<p style="text-align:center;">
	<span style="color:#999999;">“星火·链网”骨干节点（珠海横琴）启动和签约仪式</span>
</p>
<p>
	<br>
</p>
<p>
	<strong>推动横琴建设数字贸易国际枢纽港</strong>
</p>
<p>
	<br>
</p>
<p>
	《横琴粤澳深度合作区建设总体方案》提出，要建设中葡国际贸易中心和数字贸易国际枢纽港，推动传统贸易数字化转型，为此推进数字产业化和产业数字化，促进数字技术与实体经济深度融合，赋能传统产业转型升级，打造具有国际竞争力的数字产业集群显得至关重要。
</p>
<p>
	<br>
</p>
<p>
	浪潮集团高级副总裁，浪潮工业互联网党委书记、董事长肖雪认为，在数字贸易发展中，数字的作用日益凸显，数据流动决定着产业的发展，作为国家的通信基础体系，数据是万物互联的基石。在他看来，基于打造可信数据自由流，数字对贸易发展的“放大、叠加、倍增”作用，能够在更高水平、更深层次推进区域融合，实现一体化发展。
</p>
<p>
	<br>
</p>
<p>
	“数据的安全可信、互通互融，是发展湾区数字经济、实现琴澳两地深度融合的基础。横琴粤澳链的落地，将有效解决数据信任问题，为粤澳两地乃至湾区数字经济发展提供技术支撑。”横琴粤澳深度合作区经济发展局代理局长李子蔚表示。
</p>
<p>
	<br>
</p>
<p>
	<strong>为粤港澳贸易经济的发展注入新动能</strong>
</p>
<p>
	<br>
</p>
<p>
	会上，中国信息通信研究院工业互联网与物联网研究所副总工程师刘阳详细介绍了“星火∙链网”区块链基础设施的设计与发展，展示了区块链技术赋能粤港澳大湾区的应用价值。“今天我们在横琴所发布的骨干节点，如同港珠澳大桥，通过桥接的形式，把全球不同的区域和地区，通过不同的主体开展建设的一些区块链子链，连接到‘星火·链网’的主链上来，通过这样的连接，把局面所做的数据交互和交易扩展到其他的行业和领域中去。”
</p>
<p>
	<br>
</p>
<p>
	关于“星火·链网”骨干节点（珠海横琴）对于粤港澳大湾区探索区块链技术上的意义，刘阳表示，“一方面，横琴作为粤澳的交汇点，未来可以做更多区块链原始技术上的一些创新交流，另一方面横琴可以作为区块链应用于跨境数据流通和交互的实验场所，最后‘星火·链网’可以运用于横琴智慧城市建设中，不同体系之间的身份管理和互联互通”。
</p>
<p>
	<br>
</p>
<p>
	“今天我们在横琴建立了‘星火·链网’的骨干节点，助力横琴粤澳深度合作区中药、民生、金融的发展，我们也愿意在这个过程中，与技术提供方和各个产业相结合，共同推动横琴在全球数字化交易体系中的发展，建立产业互联互通的标准，推动整个数字产业和数字贸易的进步。”肖雪表示。
</p>
<p>
	<br>
</p>
<p>
	作为国家区块链与工业互联网新型融合基础设施，“星火·链网”基于现有国家顶级节点，以工业互联网为主要场景，以网络标识这一重要的数字化资源为切入点，以区块链技术为自主创新的核心突破口，并与芯片技术、人工智能相结合发展，持续赋能产业链发展，为发展数字经济发挥重要促进作用。
</p>
<p>
	<br>
</p>
<p>
	记者 李灏莞 见习记者 陈秀岑
</p>
                    </div>
                    <div class="art-bott flex flex-wrap-wrap flex-justify-between flex-align-center">
                        <a href="/News/1" class="art-btn btn-hvr" ondragstart="return false">返回</a>
                        
                    </div>
                    <div class="arc-nav">
                        <a href="/NewsDetail/36" ondragstart="return false">上一条 :  星火体系 | “星火·链网”骨干节点（珠海横琴）创新应用——“澳优码”亮相澳门科技博览会</a>
                        <a href="/NewsDetail/52" ondragstart="return false">下一条 : 粤港澳数字贸易提速！“横琴粤澳链”落地</a>
                    </div>
                </div>
</template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .article .art-cont {
    background: #fff;
    width: calc(70% - 80px);
    padding: 50px 40px;
    overflow: hidden;
    border-radius: 8px;
}
.article .art-cont h1 {
    color: #333;
    font-weight: 700;
}
    .article .art-cont h1 {
        font-size: 26px;
    }

    .article .art-cont .title-info {
        font-size: 14px;
        color: #888;
        font-family: OPPOSans-H;
        padding-left: 30px;
        height: 20px;
        line-height: 22px;
        background: url(@/assets/images/news-time.png) no-repeat left center;
        margin: 30px 0;
    }

    .article .art-bott {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #f0f0f0;
        align-items: center;
    }
    .article .art-bott .art-btn {
        background: #ea5413;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 110px;
        height: 42px;
        font-weight: 700;
        color: #fff;
        border-radius: 30px;
        transition: all .4s ease;
        font-size: 16px;
    }
    .btn-hvr:hover {
        border-color: transparent;
        box-shadow: 0 0 0 .2rem rgba(234, 84, 19, .5);
    }
    .article .arc-nav a {
        position: relative;
        display: block;
        font-size: 14px;
        color: #666;
        padding-left: 15px;
        transition: all .4s ease;
        font-weight: 700;
    }

  </style>